import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent  implements OnInit {

  loginForm: FormGroup;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;



  invalidMessage =null;
  isInvalidData = false;
  errorMessage = '';
  roles: string[] = [];

  validationMessages = {
    'username': { 'required': 'Username is required' },
    'password': { 'required': 'Password is required' },
  };

  formErrors = {
    'username': "",
    'password': "",
  };

  constructor (
    private fb: FormBuilder,
    private router : Router,
    private authService: AuthService,
    private toastr: ToastrService,
    ) { }

  ngOnInit() {
    this.initForm();
    this.keepMeLoggedIn();
 
    this.loginForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.loginForm);
    });

  }

  initForm(){
    this.loginForm = this.fb.group({
      username : ['', Validators.required],
      password : ['', Validators.required],
      rememberMe : [''],
    });
  }

  keepMeLoggedIn(){
    const userDataExist = this.authService.isStoredData()
    const userData = this.authService.getUserData()
        if(userDataExist.username && userDataExist.passowrd){
        this.loginForm.patchValue({
          username : userData.username,
          password : atob(userData.passowrd),
          rememberMe : true
        });
    }
  }

  onSubmit() {
    var getFormData : any;
    getFormData = this.loginForm.value;
    this.showProcessingIndicator = true; 
        this.authService.login(getFormData).subscribe(
        (res) => {
          if(res.success === 0){
            this.isInvalidData  = true;
            this.invalidMessage = res.message;
            this.showProcessingIndicator = false; 
            console.log(this.invalidMessage);
              
          }else{
            this.isInvalidData  =false;
            this.invalidMessage = null;
            localStorage.setItem('token',res.token);
            var encodePwd = btoa(getFormData.password);
            sessionStorage.setItem('username',getFormData.username);
            if(getFormData.rememberMe){
              sessionStorage.setItem('password',encodePwd);
            }else{
              sessionStorage.removeItem('password');
            }
            this.showProcessingIndicator = false; 
            this.router.navigate(['/pages']);
          } 
          console.log(res);                                               

          },        
        (err) =>  {
            this.toastr.error('login failed. check your internet connection');                            
            this.showProcessingIndicator = false;
            console.log(err);
          }, 
        )
  }



   logValidationErrors(group: FormGroup = this.loginForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      this.invalidMessage = null;
      if(isDirty)
      {
        this.loginForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


} // end class
